import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IButtonItem {
  _id: string;
  label: string;
  link?: string;
}

export interface IButtonVerticalItem extends IButtonItem {
  sublabel?: string;
  icon?: string; // URL to SVG
}

export interface IButtons {
  id: string;
  type: MESSAGES.BUTTONS | MESSAGES.BUTTONS_VERTICAL;
  rm: boolean;
  nodeId: string;
  items: IButtonVerticalItem[];
  role?: boolean;
}

export const createButtons = (data): IButtons => ({
  id: data.id || uuid(),
  type: data.type,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
  items: data.items,
});
